import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    ArcElement,
    Tooltip,
    Legend,
    Filler
} from 'chart.js/auto';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Filler);

const bar_line_mix_chart = ({ data, areaName, termTab }) => {

    const labels = data?.map(item => item.PTMIINDT);
    // 전국 전송건수(일별)
    const dayAllCnt = data?.map(item => item.ALL_CNT);
    // 전국 전송건수(월별,연도별)
    const allCnt = data?.map(item => item.CNT);
    // 기관 전송건수
    const myCnt = data?.map(item => item.MY_CNT);
    // 기관 생활권역 전송건수
    const allAvg = data?.map(item => item.ALL_AVG);

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        spanGaps: false,
        plugins: {
            legend: {
                position: 'bottom',
                display: false
            },
            title: {
                display: false,
                text: areaName !== undefined ? '전송 건수' : '전국 전송 건수',
                align: 'start',
                font: { size: 16 },
                padding: { bottom: 20 }
            }
        },
        scales: {
            y: {
                display: true,
                ticks: {
                    display: true,
                    beginAtZero: false,
                },
            }
        },
    }

    const chartData = {
        labels,
        datasets: areaName !== undefined ?
            [
                {
                    type: 'line',
                    label: areaName?.REGIONNAME + ' 평균',
                    data: allAvg,
                    borderColor: 'rgb(41, 198, 204)',
                    backgroundColor: 'rgb(41, 198, 204)',
                    fill: {
                        target: 'origin',
                        above: 'rgba(41, 198, 204, 0.15)'
                    }
                },
                {
                    type: 'bar',
                    label: areaName?.EMOGDESC,
                    data: myCnt,
                    borderColor: 'rgb(0, 133, 138)',
                    backgroundColor: 'rgb(0, 133, 138)',
                    maxBarThickness: 40,
                },
            ]
            :
            [
                {
                    type: 'bar',
                    label: '전국 전송건수',
                    data: termTab === 'day' ? dayAllCnt : allCnt,
                    backgroundColor: 'rgb(0, 133, 138)',
                    borderColor: 'rgb(0, 133, 138)',
                    maxBarThickness: 40,
                }
            ]
    }

    return (
        <div className='w-full h-full'>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default bar_line_mix_chart;
